// redux/features/sales/customerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import customerService from "../../../services/customerService";

const initialState = {
  customers:  [],
  customer:   null,
  isLoading:  false,
  error:      null,
};

export const getCustomers = createAsyncThunk("customer/getAll", async (_, thunkAPI) => {
  try { return await customerService.getCustomers(); }
  catch (error) { return thunkAPI.rejectWithValue(error.response?.data?.message || error.message); }
});

export const createCustomer = createAsyncThunk("customer/create", async (data, thunkAPI) => {
  try { return await customerService.createCustomer(data); }
  catch (error) { return thunkAPI.rejectWithValue(error.response?.data?.message || error.message); }
});

export const getSingleCustomer = createAsyncThunk("customer/getSingle", async (id, thunkAPI) => {
  try { return await customerService.getSingleCustomer(id); }
  catch (error) { return thunkAPI.rejectWithValue(error.response?.data?.message || error.message); }
});

export const updateCustomer = createAsyncThunk("customer/update", async ({ id, data }, thunkAPI) => {
  try { return await customerService.updateCustomer(id, data); }
  catch (error) { return thunkAPI.rejectWithValue(error.response?.data?.message || error.message); }
});

export const deleteCustomer = createAsyncThunk("customer/delete", async (id, thunkAPI) => {
  try { return await customerService.deleteCustomer(id); }
  catch (error) { return thunkAPI.rejectWithValue(error.response?.data?.message || error.message); }
});

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    resetCustomerState: (state) => {
      state.isLoading = false;
      state.error     = null;
      state.customer  = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomers.pending,   (state) => { state.isLoading = true; })
      .addCase(getCustomers.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customers = action.payload;
      })
      .addCase(getCustomers.rejected,  (state, action) => {
        state.isLoading = false; state.error = action.payload;
      })
      .addCase(createCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customers.push(action.payload);
      })
      .addCase(getSingleCustomer.fulfilled, (state, action) => {
        state.isLoading = false; state.customer = action.payload;
      })
      .addCase(updateCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customers = state.customers.map(c =>
          c._id === action.payload._id ? action.payload : c
        );
      })
      .addCase(deleteCustomer.fulfilled, (state, action) => {
        state.isLoading = false;
        state.customers = state.customers.filter(c => c._id !== action.payload._id);
      });
  },
});

export const { resetCustomerState } = customerSlice.actions;
export default customerSlice.reducer;